var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"is-typing"},[_c('div',{staticClass:"jump1"}),_c('div',{staticClass:"jump2"}),_c('div',{staticClass:"jump3"})])
}]

export { render, staticRenderFns }